import React from 'react';
import { Route } from 'react-router-dom';
import RequireAuth from './RequireAuth';
import SubMatGClientRouteGuard from './SubMatGClientRouteGuard';
import { G04docuFileManagement } from "../components/G04docuFile";
import { G04docuMaterialApprovalManagement } from "../components/G04docuMaterialApproval";
import { G04docuAlarmSettingManagement } from "../components/G04docuAlarmSetting";
import { G04docuSearchManagement } from "../components/G04docuSearch";
import { G04docuSubMatFolderManagement, SubMatFolderExpiryReviewManagement, SubMatFolderSendManagement } from "../components/G04docuSubMatFolder";
import { G04docuSubMatTemplateManagement } from "../components/G04docuSubMatTemplate";
import { GProjectManagement } from "../components/GProject";
import { GSendG04docuManagement, GSendG04docuDownloadPage } from '../components/GSendG04docu';

const guardSubMat = (sessionUser, path, element) => (
  <RequireAuth sessionUser={sessionUser}>
    <SubMatGClientRouteGuard sessionUser={sessionUser} path={path}>
      {element}
    </SubMatGClientRouteGuard>
  </RequireAuth>
);

// 자재승인서 관리
const MaterialApproveRoute = ({sessionUser}) => {

    return (
        <>
            {/* 서류첨부 */}
            <Route path="/g04docuFiles" element={
                guardSubMat(sessionUser, '/g04docuFiles', <G04docuFileManagement />)
            } />
            {/* 부자재 서류등록 */}
            <Route path="/g04docuSubMatFolders" element={
                guardSubMat(sessionUser, '/g04docuSubMatFolders', <G04docuSubMatFolderManagement />)
            } />
            {/* 부자재 만료일 일괄점검 */}
            <Route path="/g04docuSubMatExpiryReview" element={
                guardSubMat(sessionUser, '/g04docuSubMatExpiryReview', <SubMatFolderExpiryReviewManagement />)
            } />
            <Route path="/g04docuSubMatSend" element={
                guardSubMat(sessionUser, '/g04docuSubMatSend', <SubMatFolderSendManagement />)
            } />
            {/* 서류첨부 알람설정 */}
            <Route path="/g04docuAlarmSettings" element={
                <RequireAuth sessionUser={sessionUser}>
                    <G04docuAlarmSettingManagement />
                </RequireAuth>
            } />
            {/* 문서검색 */}
            <Route path="/g04docuSearch" element={
                guardSubMat(sessionUser, '/g04docuSearch', <G04docuSearchManagement />)
            } />
            {/* 전송문서 보관함 */}
            <Route path="/gsendG04docus" element={
                <RequireAuth sessionUser={sessionUser}>
                    <GSendG04docuManagement />
                </RequireAuth>
            } />
            <Route path="/gsendG04docus/download" element={
                // <RequireAuth sessionUser={sessionUser}>
                <GSendG04docuDownloadPage />
                // </RequireAuth>
            } />
            {/* 부자재 템플릿 */}
            <Route path="/g04docuSubMatTemplate" element={
                guardSubMat(sessionUser, '/g04docuSubMatTemplate', <G04docuSubMatTemplateManagement />)
            } />
            {/* 자재승인서 발급 */}
            <Route path="/g04docuGenerateFile" element={
                guardSubMat(sessionUser, '/g04docuGenerateFile', <GProjectManagement />)
            } />
            <Route path="/g04docuGenerateFileNew" element={
                guardSubMat(sessionUser, '/g04docuGenerateFileNew', <GProjectManagement />)
            } />
            {/* 자재승인서 보관함 */}
            <Route path="/g04docuMaterialApproval" element={
                guardSubMat(sessionUser, '/g04docuMaterialApproval', <G04docuMaterialApprovalManagement />)
            } />
            {/* 성적서 검색
            <Route path="/g04docuGTests" element={
                <RequireAuth sessionUser={sessionUser}>
                    <G04docuGTestManagement />
                </RequireAuth>
            } /> */}
        </>
    );
};

export default MaterialApproveRoute;

